<template>
  <div>
    <el-form ref="form" :model="form" label-width="190px" :disabled="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <ImgReview
              lebal="身份证人像面照片"
              :src="form.identificationImg"
              error="未上传"
            />
            <ImgReview
              lebal="身份证国徽面照片"
              :src="form.identificationBackImg"
              error="未上传"
            />
            <ImgReview
              lebal="统一社会信用代码照片"
              :src="form.businessLicenseImg"
              error="未上传"
            />
            <ImgReview
              lebal="道路运输经营许可证照片"
              :src="form.roadPermitNumberImg"
              error="未上传"
            />

            <ImgReview
              lebal="安全责任险照片"
              :src="form.safeDutyInsureImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车队名称" prop="linkMan">
            <!-- 解决自动填充问题 -->
            <!-- <el-input type="text" style="position: fixed; bottom: -9999px;"></el-input> -->
            <el-input
              v-model.trim="form.linkMan"
              placeholder="请输入车队名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联系人" prop="name" label-width="100px">
            <el-input v-model.trim="form.name" placeholder="请输入联系人" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入联系方式"
              autocomplete="off"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col v-if="isAdmin || dirverLeader" :span="12">
          <el-form-item label="是否清分" prop="isShare">
            <el-select v-model="form.isShare">
              <el-option
                v-for="item in isShareOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码" prop="password">
            <!-- 解决自动填充问题 -->
            <el-input
              type="password"
              style="position: fixed; bottom: -9999px;"
            />
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="请输入密码，默认abcd1234"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            v-if="compIsShare && (isAdmin || dirverLeader)"
            label="清分比率(%)"
            prop="shareRatio"
          >
            <el-input
              v-model="form.shareRatio"
              placeholder="请输入0-100的正整数"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作单位" prop="workCompany">
            <el-input v-model="form.workCompany" placeholder="请输入工作单位" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通信地址" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              :options="parentData.areaOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="homeAddress">
            <el-input v-model="form.homeAddress" placeholder="请输入详细地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人代表名称" prop="legalPerson">
            <el-input
              v-model.trim="form.legalPerson"
              placeholder="请输入法人代表名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" prop="identificationNumber">
            <el-input
              v-model="form.identificationNumber"
              placeholder="请输入身份证号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="身份证有效期" prop="idCardDueDate">
            <el-date-picker
              v-model="form.idCardDueDate"
              :class="form.hasDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDueDate"
              @change="
                value => {
                  this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输经营许可证号" prop="roadPermitNumber">
            <el-input
              v-model="form.roadPermitNumber"
              placeholder="请输入道路运输经营许可证号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码" prop="businessLicenseNumber">
            <el-input
              v-model="form.businessLicenseNumber"
              placeholder="请输入统一社会信用代码"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="允许实际承运人抢单" prop="allowDriverReceive">
            <el-select v-model="form.allowDriverReceive">
              <el-option
                v-for="item in allowDriverReceiveOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form v-if="review" ref="formData" :model="form" label-width="180px">
      <el-form-item label="" prop="authMsg">
        <el-input
          v-model="authMsg"
          placeholder="请输入审核(驳回)信息"
          type="textarea"
          maxlength="100"
          show-word-limit
          :autosize="{ minRows: 4 }"
          clearable
        />
      </el-form-item>
    </el-form>
    <!-- 审核按钮 -->
    <el-row v-if="review" class="_btns">
      <el-button type="primary" @click="funcSubmit">
        审核通过
      </el-button>
      <el-button type="danger" @click="funcRefuse">
        审核驳回
      </el-button>
    </el-row>
  </div>
</template>
<script>
import { isTaxOpen } from "@/api/driver.js";
import ImgReview from "@/components/ImgReview";
import request from "@/utils/request";
import { insuranceType } from "@/api/orderform";
export default {
  name: "DriverEdit",
  components: {
    ImgReview
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          vehicleLicenseColorList: [],
          mode: "detail"
        };
      }
    }
  },
  data() {
    return {
      showExtra: true,
      ctmsShow: true,
      hasTaxOpen: "",
      authMsg: "",
      otherItems: true,
      linkageInvalid: true,
      submitShow: true,
      isAdmin: false,
      code: "",
      form: {
        isHasTrailer: 0
      },
      // 挂车
      isHasTrailerOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 挂靠车辆
      isLinkedOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 是否清分
      isShareOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 允许抢单
      allowDriverReceiveOptions: [
        { label: "允许", value: 0 },
        { label: "禁止", value: 1 }
      ]
    };
  },
  computed: {
    compTrailer() {
      return this.form.isHasTrailer === 1 ? true : false;
    },
    compIsShare() {
      return this.form.isShare == 1 ? true : false;
    },
    review() {
      return this.parentData.model === "review" ? true : false;
    }
  },
  watch: {},
  created() {
    // const code = this.$route.query.code
    this.form = {};
    isTaxOpen().then(res => {
      this.hasTaxOpen = res.data;
    });
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
  },
  methods: {
    getDriver(code) {
      this.code = code;
      request({
        url: `/ntocc-basic-api/driver/${code}`,
        method: "get"
      }).then(response => {
        let vehicleVO = response.data.vehicleVO || {};
        this.form = Object.assign({}, response.data, vehicleVO);
        this.authMsg = response.data.authMsg || "";
        this.$set(this.form, "areaList", []);
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
      });
      insuranceType(this.instype).then(response => {
        this.locationSourceoptions = response.data.records;
      });
    },
    // 同意审核
    funcSubmit() {
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/updateAuthStatus`,
        method: "post",
        params: {
          code: this.code,
          authStatus: 3
        }
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
    },
    // 拒绝审核
    funcRefuse() {
      if (this.authMsg.trim() == "") {
        this.$message.warning("请输入驳回原因");
        return;
      }
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/updateAuthStatus`,
        method: "post",
        params: {
          code: this.code,
          authStatus: 2,
          authMsg: this.authMsg
        }
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
._btns {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
.remarks {
  color: #d01415;
  font-size: 10px;
}
::v-deep .dif {
  .el-form-item__content {
    display: flex;
    .el-input {
      flex: 1;
      margin-right: 20px;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
</style>
